import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBbDdBy_G9nLkZbREIef-11aFRqVp24u08",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "barcode-1b39e.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "barcode-1b39e",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "barcode-1b39e.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "548341187807",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:548341187807:web:c52a22ea58c038dd5cd56a"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

export default db;
